import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="w-full">
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center justify-between gap-3 px-6 py-6 text-xs text-text-muted sm:flex-row sm:px-8">
        <p>
          &copy; {new Date().getFullYear()}{' '}
          <a
            href="https://anavantistech.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-sm underline-offset-2 transition-colors hover:text-text hover:underline focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Anavantis Technologies LLC
          </a>
          . All rights reserved.
        </p>
        <nav className="flex items-center gap-5">
          <Link
            to="/terms"
            className="rounded-sm transition-colors hover:text-text focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Terms
          </Link>
          <Link
            to="/privacy"
            className="rounded-sm transition-colors hover:text-text focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Privacy
          </Link>
          <Link
            to="/support"
            className="rounded-sm transition-colors hover:text-text focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            Support
          </Link>
        </nav>
      </div>
    </footer>
  );
}
